module.exports = __webpack_public_path__ + "img/rightAni.ef9029a5.png";